import React from 'react';
import {Suggestions} from 'components';

export function Passions(props) {
  return (
    <Suggestions.List {...props}>
      <p>Reading books</p>
      <p>Exploring new places</p>
      <p>Playing games</p>
      <p>Building a business</p>
      <p>Helping others</p>
      <p>Shopping</p>
      <p>Teaching kids</p>
      <p>Learning history</p>
      <p>Writing my memories</p>
      <p>Developing a product</p>
      <p>Being outdoors</p>
      <p>Cooking</p>
      <p>Playing the Piano</p>
      <p>Dancing with my lover</p>
      <p>Spending time with friends</p>
      <p>Walking in nature</p>
      <p>Traveling</p>
      <p>Painting</p>
      <p>Help ... do ...</p>
      <p>Creating ...</p>
      <p>Leading a ...</p>
      <p>Contributing to ...</p>
      <p>Learning to ...</p>
      <p>Building a ...</p>
    </Suggestions.List>
  );
}
